import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useNavigate } from 'react-router-dom'
import { Card, CardHeader, CardTitle, Col, Row } from 'reactstrap'

const ServiciosPintura = () => {
    const navigate = useNavigate()

    return (
        <AllowedAccess permissions={['IMPORTADORA', '49_ADMIN']} renderAuthFailed={navigate('/inicio')}>
            <div className='content'>
                <Row>
                    <Col md='12'>
                        <Card>
                            <CardHeader>
                                <CardTitle tag='h4'>
                                    Servicios De Pintura
                                </CardTitle>
                            </CardHeader>
                        </Card>
                    </Col>
                </Row>
            </div>
        </AllowedAccess>
    )
}

export {
    ServiciosPintura
}